export default __webpack_public_path__ + "static/media/GT-Ultra-Standard-Ultra.2c79d87b.otf";